import {
  CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_BEGIN,
  CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_SUCCESS,
  CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_FAILURE,
  CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
export function customFunctionLogs(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/custom-function/functionLogs/${args.customFunctionId}`,
          {
            page: args.page,
          },
          header,
        )
        .then(
          (res) => {
            if (res.status === 200 && res.data) {
              dispatch({
                type: CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_SUCCESS,
                data: res.data,
              });
              resolve(res);
            } else {
              const errMsg = getErrorMessageFromResponse(res);
              dispatch({
                type: CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_FAILURE,
                data: { error: errMsg },
              });
              toast.error(`Fetching logs failed`);
              reject(errMsg);
            }
          },
          (err) => {
            const errMsg = getErrorMessageFromResponse(err.response || err);
            dispatch({
              type: CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_FAILURE,
              data: { error: errMsg },
            });
            toast.error(`Fetching logs failed`);
            reject(errMsg);
          },
        );
    });

    return promise;
  };
}

export function dismissCustomFunctionLogsError() {
  return {
    type: CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_BEGIN:
      return {
        ...state,
        customFunctionLogsPending: true,
        customFunctionLogsError: null,
      };

    case CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_SUCCESS:
      return {
        ...state,
        customFunctionLogsPending: false,
        customFunctionLogsError: null,
        customFunctionLogsResult: action.data,
      };

    case CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_FAILURE:
      return {
        ...state,
        customFunctionLogsPending: false,
        customFunctionLogsError: action.data.error,
      };

    case CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_DISMISS_ERROR:
      return {
        ...state,
        customFunctionLogsError: null,
      };

    default:
      return state;
  }
}
